const CNY_FORMATTER = new Intl.NumberFormat("zh-CN", {
  style: "currency",
  currency: "CNY",
  maximumFractionDigits: 0
});

const NUMBER_FORMATTER = new Intl.NumberFormat("zh-CN", { maximumFractionDigits: 0 });

export function formatCny(value: number | null | undefined, opts?: { showZero?: boolean; placeholder?: string }): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return opts?.placeholder ?? "—";
  }
  if (value === 0 && !opts?.showZero) {
    return opts?.placeholder ?? "—";
  }
  return CNY_FORMATTER.format(value);
}

export function formatCnyApprox(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value) || value === 0) return "—";
  return `约 ${CNY_FORMATTER.format(value)}`;
}

export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return NUMBER_FORMATTER.format(value);
}

const DATE_FORMATTER = new Intl.DateTimeFormat("zh-CN", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
});

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return DATE_FORMATTER.format(d);
}

export function formatRelativeTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const diffMs = d.getTime() - Date.now();
  const diffDays = Math.round(diffMs / 86_400_000);
  if (diffDays === 0) return "今天";
  if (diffDays === 1) return "明天";
  if (diffDays === -1) return "昨天";
  if (diffDays > 0) return `${diffDays} 天后`;
  return `${Math.abs(diffDays)} 天前`;
}

export function daysSinceReview(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const diffDays = Math.floor((Date.now() - d.getTime()) / 86_400_000);
  return diffDays >= 0 ? diffDays : 0;
}
